<template>
  <div class="sub-header-menu">
    <div class="sub-header-inner">
      <!-- Hamburger (mobile only) -->
      <button class="hamburger" @click="toggleMenu" aria-label="Menu">
        <img alt="menu" class="menu-icon" src="@/assets/icons/menu.svg"/>
      </button>

      <!-- Logo -->
      <img class="logo" alt="logo" :src="require('@/assets/images/logo.svg')"/>

      <!-- Overlay -->
      <div class="mobile-overlay" v-show="isMenuOpen" @click="toggleMenu"></div>

      <!-- Nav links -->
      <nav class="nav-links" :class="{ 'nav-open': isMenuOpen }">
        <router-link
          class="nav-link"
          :to="HOME_ROUTE"
          :class="{ 'active-route': isActiveRoute(HOME_ROUTE) }"
          @click="isMenuOpen = false">
          Accueil
        </router-link>
        <router-link
          class="nav-link"
          :to="ESPACE_FOURNISSEURS_ROUTE"
          :class="{ 'active-route': isActiveRoute(ESPACE_FOURNISSEURS_ROUTE) }"
          @click="isMenuOpen = false">
          Espace Fournisseurs
        </router-link>
        <router-link
          class="nav-link"
          :to="SEARCH_ROUTE"
          :class="{ 'active-route': isActiveRoute(SEARCH_ROUTE) }"
          @click="isMenuOpen = false">
          Recherche Avancée
        </router-link>
        <router-link
          class="nav-link"
          :to="DEMAT_ROUTE"
          :class="{ 'active-route': isActiveRoute(DEMAT_ROUTE) }"
          @click="isMenuOpen = false">
          Dématérialisation
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
import { HOME_ROUTE, SEARCH_ROUTE, ESPACE_FOURNISSEURS_ROUTE, DEMAT_ROUTE } from '@/router/routes';

export default {
  name: 'SubHeaderView',
  data() {
    return {
      isMenuOpen: false,
      HOME_ROUTE,
      SEARCH_ROUTE,
      ESPACE_FOURNISSEURS_ROUTE,
      DEMAT_ROUTE
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    }
  }
}
</script>

<style>
.sub-header-menu {
  width: 100%;
  padding: 1.1rem 14.71rem;
  position: relative;
  z-index: 15;
}

.sub-header-inner {
  display: flex;
  align-items: center;
}

/* Logo */
.logo {
  width: 13rem;
  flex-shrink: 0;
}

/* Nav links – horizontal on desktop */
.nav-links {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  margin-left: 3rem;
}

.nav-link {
  text-decoration: none;
  color: #304353;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  white-space: nowrap;
  transition: color 0.15s;
}

.nav-link:hover {
  color: #9a8060;
}

.active-route {
  text-decoration: underline !important;
}

/* Hamburger – hidden on desktop */
.hamburger {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-right: 1rem;
}

.menu-icon {
  width: 1.5rem;
  height: auto;
}

/* Mobile overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
}

/* ── Responsive breakpoints ── */

/* Large screens: reduce side padding progressively */
@media (max-width: 1400px) {
  .sub-header-menu {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}

@media (max-width: 1100px) {
  .sub-header-menu {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .nav-links {
    gap: 1.75rem;
  }
}

@media (max-width: 900px) {
  .sub-header-menu {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .nav-links {
    gap: 1.25rem;
    margin-left: 1.5rem;
  }
  .logo {
    width: 10rem;
  }
  .nav-link {
    font-size: 0.875rem;
  }
}

/* Mobile: hamburger + slide-in drawer */
@media (max-width: 680px) {
  .hamburger {
    display: block;
  }

  .logo {
    width: 9rem;
  }

  .nav-links {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 75%;
    max-width: 280px;
    background: white;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    margin-left: 0;
    padding: 2rem 1.5rem;
    z-index: 1000;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.15);
  }

  .nav-links.nav-open {
    display: flex;
  }

  .nav-link {
    font-size: 1rem;
    font-weight: 500;
    padding: 0.75rem 0;
    width: 100%;
    border-bottom: 1px solid #f0ece4;
  }

  .mobile-overlay {
    display: block;
  }
}
</style>
